module.exports = __webpack_public_path__ + "static/logo-boco-acd16ce72ff587738dca4c5cdec5a772.png";